module.exports = __webpack_public_path__ + "static/media/sandwich_vert.c634ce3f.png";